import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import block from 'bem-cn';
import { GridLoader } from 'react-spinners';

import { actions } from '../';

import './MyBets.scss';

const MyBets = () => {
  const b = block('my-bets');
  const locale = useSelector(state => state.locale.locale);
  const { myBets, isProcess } = useSelector(state => state.history);
  // const { roundID } = useSelector(state => state.game);
  const { activeBalls } = useSelector(state => state.game);
  const currency = useSelector(state => state.auth.currency);
  const dispatch = useDispatch();
  const gameStatus = useSelector(state => state.game.gameStatus);

  useEffect(() => {
    dispatch(actions.getMyBets());
  }, [dispatch])

  const resultList = useMemo(() => (
    myBets.map((t, i) => {
      let status = 'lose';
      if (t.win_amount > 0) {
        status = 'win';
      }
      if (activeBalls.some((item) => item.roundID === t.game_id) && gameStatus === 1) {
        status = 'placed'
      } 
      return <div key={`${t.value}${t.round_id}${i}`} className={b('item')}>
        <div className={b('column')}>
          {t.game_id}
        </div>
        <div className={b('column')}>
          {`${t.bet_amount.toFixed(2)} ${currency}`}
        </div>
        <div className={b('column')}>
          {activeBalls.some((item) => item.roundID === t.game_id) ? '' : `${t.win_amount.toFixed(2)} ${currency}`}
        </div>
        <div className={b('column')}>
          <div className={b('status', { status })}>
            {locale[status]}
          </div>
        </div>
      </div>
    }
    )
  ), [b, currency, gameStatus, locale, myBets, activeBalls])

  return <section className={b()}>
    <GridLoader loading={isProcess} color="var(--accent-color)" size={50} css={{ position: 'fixed', top: '50%', transform: 'translateY(-50%)', zIndex: 100 }}/>
    <div className={b('header')}>
      <div className={b('column')}>
        {locale.roundID}
      </div>
      <div className={b('column')}>
        {locale.betAmount}
      </div>
      <div className={b('column')}>
        {locale.winAmount}
      </div>
      <div className={b('column')}>
      </div>
    </div>
    <div className={b('items')}>
      {resultList}
    </div>
  </section>
}

export default MyBets;